
<div class="graph-wrap">
  <!-- SVG CONNECTION LINES -->
  <svg class="svg-layer">

  <!-- LEFT LINE -->
  <line
    *ngIf="leftLine"
    [attr.x1]="leftLine.x1"
    [attr.y1]="leftLine.y1"
    [attr.x2]="leftLine.x2"
    [attr.y2]="leftLine.y2"
    stroke="#9fb0cc"
    stroke-width="2"
    stroke-dasharray="6 4"
  ></line>

  <!-- RIGHT LINE -->
  <line
    *ngIf="rightLine"
    [attr.x1]="rightLine.x1"
    [attr.y1]="rightLine.y1"
    [attr.x2]="rightLine.x2"
    [attr.y2]="rightLine.y2"
    stroke="#9fb0cc"
    stroke-width="2"
    stroke-dasharray="6 4"
  ></line>

  <!-- PARENT HIERARCHY LINES -->
  <line
    *ngFor="let line of parentLines"
    [attr.x1]="line.x1"
    [attr.y1]="line.y1"
    [attr.x2]="line.x2"
    [attr.y2]="line.y2"
    stroke="#9fb0cc"
    stroke-width="2"
    stroke-dasharray="6 4"
  ></line>

</svg>

  <!-- CENTER HIERARCHY -->
  <div class="center-tree">
    <!-- ONLY FOR HCP: SHOW PARENT ABOVE CENTER NODE -->
    <div
      *ngIf="selectedNodeType === 'HCP' && topParentNode"
      class="top-parent-container"
    >
      <div class="node parent-node">
        <div class="title">
          {{ topParentNode.name }}
        </div>

        <div class="id">
          {{ topParentNode.id }}
        </div>

        <div class="level">Parent HCA</div>
      </div>

      <div class="parent-line"></div>
    </div>
    <div class="center-wrapper">
      <div
        *ngFor="let node of hierarchyNodes"
        #hierarchyNode
        class="node hierarchy-node"
        [class.searched-node]="node.id === rcmId"
        [attr.id]="
  node.id === rcmId
    ? 'selected-node'
    : null
"
      >
        <div class="title">
          {{ node.name }}
        </div>

        <div class="id">
          {{ node.id }}
        </div>

        <div class="level">
          {{ node.level }}
        </div>
      </div>
    </div>
  </div>

  <!-- LEFT SIDE -->
  <div class="left-stack" #leftStack *ngIf="!isHcpGraphMode">
    <div *ngIf="hasHcpChildren; else noHcp">
      <div class="stack-title">HCP Children</div>

      <div
  *ngFor="let item of graph.leftChildren"
  class="node hcp child-node"
  [class.more-node]="item.isMoreNode"
>
        <div class="title">
  {{ item.name || "-" }}
</div>

<div class="id" *ngIf="!item.isMoreNode">
  {{ item.id }}
</div>

<div class="level">
  {{ item.isMoreNode ? ('Total: ' + item.totalCount) : 'HCP' }}
</div>
      </div>
    </div>

    <ng-template #noHcp>
      <div class="node empty-box">No HCP children</div>
    </ng-template>
  </div>

  <!-- RIGHT SIDE -->
  <div class="right-stack" #rightStack *ngIf="!isHcpGraphMode">
    <div *ngIf="hasHcaChildren; else noHca">
      <div class="stack-title">HCA Children</div>

      <div
  *ngFor="let item of graph.rightChildren"
  class="node hca child-node"
  [class.more-node]="item.isMoreNode"
>
        <div class="title">
  {{ item.name || "-" }}
</div>

<div class="id" *ngIf="!item.isMoreNode">
  {{ item.id }}
</div>

<div class="level">
  {{
    item.isMoreNode
      ? ('Total: ' + item.totalCount)
      : (item.level || 'HCA')
  }}
</div>
      </div>
    </div>

    <ng-template #noHca>
      <div class="node empty-box">No HCA children</div>
    </ng-template>
  </div>
  <!-- BACK BUTTON -->
<div class="graph-header">
  <button class="back-btn" (click)="goBack()">
    <i class="bi bi-arrow-left-circle"></i>
    Back
  </button>
</div>
  <!-- AFFILIATION SUMMARY -->
<div class="affiliation-summary">
  <div class="summary-title">
    Affiliation Summary
  </div>
 <hr />
  <div class="summary-row">
    <span class="summary-label">Searched : </span>
    <span class="summary-value">
      {{ affiliationSummary.searchedLevel }}
    </span>
  </div>

  <div class="summary-row">
    <span class="summary-label">RCM ID : </span>
    <span class="summary-value">
      {{ affiliationSummary.rcmId }}
    </span>
  </div>

  <div class="summary-row">
    <span class="summary-label">Name : </span>
    <span class="summary-value">
      {{ affiliationSummary.name }}
    </span>
  </div>

  <hr />

<div class="below_details">
  <div class="summary-row">
    <span class="summary-label">Total HCA Children : </span>
    <span class="summary-value" style="display: right;">
      {{ affiliationSummary.totalHcaChildren }}
    </span>
  </div>

  <div class="summary-row">
    <span class="summary-label">Total HCP Children : </span>
    <span class="summary-value">
      {{ affiliationSummary.totalHcpChildren }}
    </span>
  </div>
  </div>
</div>
</div>
